import { CASHOUT } from "../actions/types"

const initalizeState = {banks: [], allBanks: [], accountName: ""};

const cashoutReducer = (state = initalizeState, action) => {
    switch(action.type) {
        case CASHOUT.CASHOUT_WALLET_SUCCESS:
            return state;

        case CASHOUT.CASHOUT_BANK_SUCCESS:
            return state;
        
        case CASHOUT.CASHOUT_BANK_FAIL:
            return state;
        
        case CASHOUT.CASHOUT_WALLET_FAIL:
            return state;
        
        case CASHOUT.FETCH_BANK_SUCCESS:
            return { ...state, banks: action.payload }
        
        case CASHOUT.FETCH_ALL_BANKS_SUCCESS:
            return { ...state, allBanks: action.payload }
        
        case CASHOUT.VERIFY_BANK_SUCCESS:
            return {...state, accountName: action.payload}

        default:
            return state;
    }
}

export default cashoutReducer;